// This file is generated by scripts/write-build-info.mjs.
export const buildInfo = {
  version: '26.11.01-73b4b39',
  hash: '73b4b39',
  generatedAt: '2026-11-01T11:17:18.432Z',
} as const;
